import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
//images import
import { LogOut } from "../../../actions/Auth_action";
import { change_Lang } from "../../../actions/Helper_action";

const User_menu = () => {
  useSelector((state) => state.HelperReducer.lang);
  useSelector((state) => state.AuthReducer.user);
  const user = useSelector((state) => state.AuthReducer.user);
  const dispatch = useDispatch();
  return (
    <Fragment>
      <li className="onhover-dropdown">
        <div className="media align-items-center">
          <img
            className="align-self-center pull-right img-50 rounded-circle blur-up lazyloaded"
            src={`/${user.image}`}
            alt="header-user"
          />
          <div className="dotted-animation">
            <span className="animate-circle"></span>
            <span className="main-circle"></span>
          </div>
        </div>
        <ul className="profile-dropdown onhover-show-div p-35 profile-dropdown-hover">
          <li>
            <Link to={`/settings/profile`}>
              <i data-feather="user"></i>
              {dispatch(change_Lang("s_settings"))}
            </Link>
          </li>
          <li>
            <Link to={`/`} onClick={() => dispatch(LogOut())}>
              <i data-feather="log-out"></i>
              {dispatch(change_Lang("s_logout"))}
            </Link>
          </li>
        </ul>
      </li>
    </Fragment>
  );
};

export default User_menu;
